"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpinCardRecommendations;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _domainServices = require("@site/domain-services");
var _utils = require("@site/utils");
var _EidCodes = _interopRequireDefault(require("../EidCodes"));
var _SpinCardRecommendationsError = _interopRequireDefault(require("./SpinCardRecommendationsError"));
var _SpinCardRecommendationsContainer = _interopRequireDefault(require("./SpinCardRecommendationsContainer"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function SpinCardRecommendations({
  plid,
  apiKey,
  urlOverride,
  domainToCheck,
  ctaProps,
  options,
  enableDynamicFontScaling,
  PriceBlock,
  language,
  AddToCartButton,
  numberOfCards = 4
}) {
  const [results, setResults] = (0, _react.useState)();
  const [isLoadingResults, setIsLoadingResults] = (0, _react.useState)(false);
  const [spinsError, setSpinsError] = (0, _react.useState)(false);
  const {
    findSpins
  } = (0, _domainServices.initializeDomainServices)({
    apiKey,
    plid,
    urlOverride
  });
  const handleSpinsError = () => {
    setSpinsError(true);
  };
  const getResults = (0, _react.useCallback)(() => {
    setIsLoadingResults(true);
    const searchTerm = domainToCheck;
    (0, _utils.logEvent)({
      eid: _EidCodes.default.MoreLikeThisSpins.Click,
      type: 'click',
      properties: {
        searchTerm
      }
    });
    (0, _utils.logImpression)(_EidCodes.default.MoreLikeThisSpins.Impression);
    findSpins({
      query: searchTerm,
      extraParams: {
        pagesize: numberOfCards
      }
    }).then(response => {
      if (response?.RecommendedDomains?.length > 0) {
        setResults(response);
      } else {
        handleSpinsError();
      }
    }).catch(() => {
      handleSpinsError();
    });
  }, [domainToCheck, findSpins, numberOfCards]);
  (0, _react.useEffect)(() => {
    if (!results && !isLoadingResults) {
      getResults();
    }
  }, [getResults, isLoadingResults, results]);
  (0, _react.useEffect)(() => {
    if (results) setIsLoadingResults(false);
  }, [results]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "spins-card-content",
    "data-cy": "spins-view-more-content",
    "data-testid": "spins-view-more-content"
  }, spinsError ? /*#__PURE__*/_react.default.createElement(_SpinCardRecommendationsError.default, {
    handleCardRecommendationsErrorClick: getResults,
    dataCy: "spins-card-recommendation-error",
    dataTestId: "spins-card-recommendation-error",
    dataEid: _EidCodes.default.MoreLikeThisSpins.ErrorLinkClick,
    messageIds: {
      title: 'domainSearchError'
    }
  }) : /*#__PURE__*/_react.default.createElement(_SpinCardRecommendationsContainer.default, {
    numberOfCards: numberOfCards,
    results: results,
    ctaProps: ctaProps,
    customClassName: "mt-2",
    options: options,
    enableDynamicFontScaling: enableDynamicFontScaling,
    PriceBlock: PriceBlock,
    language: language,
    AddToCartButton: AddToCartButton,
    hideIcon: true
  }));
}
SpinCardRecommendations.propTypes = {
  plid: _propTypes.default.number,
  apiKey: _propTypes.default.string.isRequired,
  urlOverride: _propTypes.default.string,
  domainToCheck: _propTypes.default.string,
  language: _propTypes.default.object,
  options: _propTypes.default.object,
  AddToCartButton: _propTypes.default.func,
  PriceBlock: _propTypes.default.func,
  enableDynamicFontScaling: _propTypes.default.bool,
  ctaProps: _propTypes.default.object,
  numberOfCards: _propTypes.default.number
};